import { Component, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageDialog } from '..';
import { DialogAction } from '../../dialog-action';
import { DialogContext } from '../../dialog-data';
import { DashboardDialogFramePart } from '../../dialog-frame/dialog-frame.part';


@Component({
	selector: 'dashboard-confirmation-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
	],
	templateUrl: './confirmation.dialog.html',
	styleUrls: ['./confirmation.dialog.scss']
})
export class ConfirmationDialog implements OnInit {

	message: string = '';
	bullets: string[] = [];
	header = 'Confirm';

	yesText = signal('Yes');
	noText = signal('No');

	yesAction: DialogAction = {
		id: 'yes',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: this.yesText,
		linkType: "no-action",
		willCloseDialog: true,
	};

	noAction: DialogAction = {
		id: 'no',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: this.noText,
		linkType: "no-action",
		willCloseDialog: true,
	};

	actions: DialogAction[] = [this.yesAction, this.noAction];
	public dialog: DialogContext<{ message: string, yesButtonText?: string, noButtonText?: string, bullets: string[] }> = inject(MAT_DIALOG_DATA);

	constructor(
		public dialogRef: MatDialogRef<MessageDialog>,
	) {
	}

	async ngOnInit() {

		if (this.dialog.data) {
			this.message = this.dialog.data.message || '';
			this.bullets = this.dialog.data.bullets;
		}

		this.yesText.set(this.dialog.data?.yesButtonText ? this.dialog.data.yesButtonText : ':Yes');
		this.noText.set(this.dialog.data?.noButtonText ? this.dialog.data.noButtonText : ':No');
	}
}
